var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('navigation',{attrs:{"title":_vm.message.title}}),_vm._v(" "),_c('div',{staticClass:"notice"},[_c('div',{staticClass:"time",domProps:{"innerHTML":_vm._s(_vm.message.content)}}),_vm._v(" "),_c('div',{staticClass:"clearfloat"})]),_vm._v(" "),_c('version')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-769b6c46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/openTime/index.vue
// module id = null
// module chunks = 